module.exports = __webpack_public_path__ + "static/media/8900_Bedroom2.0f74c424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/8900_Bedroom2.jpg
// module id = 224
// module chunks = 0